import _ from 'lodash';
import collectionUtils from '../../../common/collection-utils';

angular.module('cian.mapDraw')
  .controller('MapDrawCtrl',
    ['$scope',
      '$window',
      '$timeout',
      '$log',
      '$uibModalInstance',
      'IMAGES_CONST',
      'YMAPS_PRESETS_CONST',
      'GeoService',
      'GeoUtils',
      'BrowserInfo',
      'AnalyticsService',
      'mapCenter',
      'selectedShapes',
      'geoFilters',
      function ($scope,
                $window,
                $timeout,
                $log,
                $uibModalInstance,
                IMAGES_CONST,
                YMAPS_PRESETS_CONST,
                GeoService,
                GeoUtils,
                BrowserInfo,
                AnalyticsService,
                // Передаются при вызове попапа:
                mapCenter,
                selectedShapes,
                geoFilters) {
        var map;
        /* Карта */
        var geoObjectCollection;
        /* Коллекция геообъектов, привязанных к тегам*/
        var drawingGeoObjectCollection;
        /* Коллекция рисуемых геообъектов */
        var contextMenu;
        var mapCursor;
        var CURSORS = {
          CROSSHAIR: 'crosshair'
        };

        const addShape = shape => {
          selectedShapes = selectedShapes.concat(shape);
          updateGeo();
        };

        const removeShape = shape => {
          selectedShapes = selectedShapes.filter(item => item.id !== shape.id);
          updateGeo();
        };

        function setCursor(type) {
          if (!_.values(CURSORS).includes(type)) {
            $log.error(`Unexpected cursor type: ${type}`);
          }
          mapCursor = map.cursors.push(type);
        }

        function clearCursor() {
          if (mapCursor) {
            mapCursor.remove();
          }
        }


        // @pure
        function isCircle(geoObject) {
          return geoObject.geometry.getType() === 'Circle';
        }

        function isPolygon(geoObject) {
          return !isCircle(geoObject);
        }


        // @pure
        var circleCoordsToRectCoords = function (center, radius) {
          return [
            [center[0] + radius, center[1] - radius], // top-left
            [center[0] + radius, center[1] + radius], // top-right
            [center[0] - radius, center[1] + radius], // bottom-right
            [center[0] - radius, center[1] - radius],  // bottom-left
          ];
        };


        const validateCoord = (property, coord) => {
          if (!_.isNumber(coord)) {
            throw new Error(`${property} should be number but it is ${JSON.stringify(coord)}`);
          }
        };


        const validateCoords = coords => {
          if (!_.isArray(coords)) {
            throw new Error(`coords should be an array but it is ${JSON.stringify(coords)}`);
          }
          validateCoord('y', coords[0]);
          validateCoord('x', coords[1]);
        };


        const validateBound = bound => {
          if (!_.isArray(bound)) {
            throw new Error(`bound should be an array but it is ${JSON.stringify(bound)}`);
          }
          validateCoords(bound[0]);
          validateCoords(bound[1]);
        };

        const validateBounds = bounds => bounds.forEach(validateBound);


        const getYCoord = coords => {
          validateCoords(coords);
          return coords[0];
        };


        const getXCoord = coords => {
          validateCoords(coords);
          return coords[1];
        };


        // Coord  :: Number
        // Coords :: [Coord, Coord]
        // Bound  :: [Coords, Coords]


        // findTop :: [Bound] -> Coords
        const findTop = bounds => {
          validateBounds(bounds);
          const coords = getYCoord(_.maxBy(_.flatten(bounds), 0));
          validateCoord('result of findTop', coords);
          return coords;
        };

        // findTop :: [Bound] -> Coords
        const findBottom = bounds => {
          validateBounds(bounds);
          const coords = getYCoord(_.minBy(_.flatten(bounds), 0));
          validateCoord('result of findBottom', coords);
          return coords;
        };

        // findTop :: [Bound] -> Coords
        const findRight = bounds => {
          validateBounds(bounds);
          const coords = getXCoord(_.maxBy(_.flatten(bounds), 1));
          validateCoord('result of findRight', coords);
          return coords;
        };

        // findTop :: [Bound] -> Coords
        const findLeft = bounds => {
          validateBounds(bounds);
          const coords = getXCoord(_.minBy(_.flatten(bounds), 1));
          validateCoord('result of findLeft', coords);
          return coords;
        };


        const createBound = ({top, left, right, bottom}) => {
          validateCoord('top', top);
          validateCoord('left', left);
          validateCoord('right', right);
          validateCoord('bottom', bottom);
          return [
            [bottom, left],
            [top, right],
          ];
        };


        // @pure
        // getUnionBound :: [Bound] -> Bound
        const getUnionBound = bounds => {
          bounds.forEach(validateBound);
          return createBound({
            top: findTop(bounds),
            left: findLeft(bounds),
            right: findRight(bounds),
            bottom: findBottom(bounds),
          });
        };

        // @pure
        var getShapesBounds = function (shapes) {
          return shapes.reduce(function (bounds, shape) {
            if (shape.geoObject.source.geometry.type === 'Polygon') {
              return bounds.concat(shape.geoObject.source.geometry.coordinates[0]);
            }
            if (shape.geoObject.source.geometry.type === 'Circle') {
              var center = shape.geoObject.source.geometry.coordinates;
              var radius = shape.geoObject.source.geometry.radius / 100000;
              return bounds.concat(circleCoordsToRectCoords(center, radius));
            }
            return bounds;
          }, []);
        };

        const getPointBound = (coords, geoObjectType) => {
          // TODO use diffenert ranges for different geoObjectType
          const range = 0.005;
          const bound = createBound({
            top: coords[0] + range,
            left: coords[1] - range,
            right: coords[1] + range,
            bottom: coords[0] - range,
          });
          return bound;
        };

        // @pure
        function joinWithSep(sep) {
          return arr => {
            return arr.join(sep);
          };
        }

        // @pure
        function flatCreateElement(...elements) {
          return _.flowRight(angular.element, joinWithSep(''), _.flatten, _.toArray)(elements);
        }

        // @pure
        function getNodeIndex(node, index) {
          if (index === undefined) {
            index = 0; // eslint-disable-line
          }
          if (node.previousSibling) {
            return getNodeIndex(node.previousSibling, index + 1);
          }
          return index;
        }


        function ContextMenu(options) {
          this._container = options.container;
          this._items = options.items;
          this._map = options.map;
          this._map.events.add(['click', 'actiontick', 'mousedown'], this.hide, this);

          this._onSelectCallbacks = [];
          this.updateMenu();
          this.hide();
        }

        ContextMenu.prototype = {
          constructor: ContextMenu,
          move: function (position) {
            // Корректируем координаты с учётом положения родителя
            // (в IE они приходят откорректированные)
            if (!BrowserInfo.isIE) {
              const parentPos = this._container.getBoundingClientRect();
              position[0] -= parentPos.left;
              position[1] -= parentPos.top;
            }

            const scrollPos = {
              // В IE body.scrollTop всегда 0
              left: (document.documentElement && document.documentElement.scrollLeft) || document.body.scrollLeft,
              top: (document.documentElement && document.documentElement.scrollTop) || document.body.scrollTop,
            };

            const menuPos = {
              left: position[0] - scrollPos.left,
              top: position[1] - scrollPos.top,
            };

            // Не позволяем меню выйти за рамки родителя
            const menuWidth = this._menu[0].offsetWidth;
            const parentWidth = this._container.offsetWidth;
            if (menuPos.left + menuWidth >= parentWidth) {
              menuPos.left = parentWidth - menuWidth;
            }
            const menuHeight = this._menu[0].offsetHeight;
            const parentHeight = this._container.offsetHeight;
            if (menuPos.top + menuHeight >= parentHeight) {
              menuPos.top = parentHeight - menuHeight;
            }

            this._menu.css(menuPos);
          },
          show: function (context) {
            this._context = context;
            this._menu.show();
            this.move(this._context.position);
          },
          hide: function () {
            this._menu.hide();
          },
          setItems: function (items) {
            $log.debug('setItems');
            this._items = items;
            this.updateMenu();
          },
          _createMenu: function () {
            return flatCreateElement(
              '<ul class="map-context-menu">',
              this._items.map(item => item.html),
              '</ul>'
            );
          },
          updateMenu: function () {
            if (!this._menu) {
              // create if no menu
              this._menu = this._createMenu();
              this._menu.appendTo(this._container);
            } else {
              this._menu.unbind('click');
              this._menu.replace(this._createMenu());
            }
            this._menu.bind('click', this.onClick.bind(this));
          },
          onSelect: function (callback) {
            this._onSelectCallbacks.push(callback);
          },
          select: function (index, event) {
            var selectedItem = this._items[index];
            if (selectedItem.onClick) {
              selectedItem.onClick(event, this._context);
            }
            this._onSelectCallbacks.forEach(function (cb) {
              cb(selectedItem, event, this._context);
            }, this);
          },
          onClick: function (event) {
            this.select(getNodeIndex(event.target), event);
            this.hide();
          }
        };


        // Индекс стартует с 1 каждый раз, как открывается карта
        var nextIndex = (function () {
          var index = 0;
          return function () {
            return ++index;
          };
        })();

        // Могут быть уже другие теги с отчётом от 1
        // Например, при переходе по урлу в window.cianConfig.query.geo лежат области:
        // "Область поиска 1" и "Область поиска 3"
        // В таком случае новые области получат имена "Область поиска 2", "Область поиска 4" и т.д.
        function generateName() {
          while (true) {
            var newName = 'Область поиска ' + nextIndex();
            const alreadyExistedTagWithNewName = selectedShapes.find(shape => shape.text === newName);
            if (!alreadyExistedTagWithNewName) {
              return newName;
            }
          }
        }

        var drawingState = {
          isDrawing: false,
          mode: ''
        };

        this.isDrawing = function (mode) {
          // $log.debug('modal.isDrawing');
          return drawingState.isDrawing && drawingState.mode === mode;
        };

        const createContextMenu = _map => {
          return new ContextMenu({
            map: _map,
            container: document.querySelector('.map-draw'),
            items: [{
              html: '<li class="map-context-menu__item">Удалить область</li>',
              onClick: (event, context) => {
                $log.debug('delete', event, context, geoObjectCollection, this);
                $timeout(function () {
                  removeShape(context.shapeObject);
                });
              }
            }]
          });
        };

        const onMapInited = () => $timeout(
          () => (this.isMapInited = true)
        );

        this.afterMapInit = function (_map) {
          const geoBounds = geoFilters.map(geoItem => {
            if (geoItem.coordinates) {
              return getPointBound(geoItem.coordinates, geoItem.type);
            }
            return null;
          }).filter(_.identity);

          map = _map;

          if (selectedShapes.length || geoBounds.length) {
            const bounds = [];

            if (selectedShapes.length) {
              const shapeBounds = getShapesBounds(selectedShapes);
              bounds.push(shapeBounds);
            }

            if (geoBounds.length) {
              bounds.push(...geoBounds);
            }

            map.setBounds(getUnionBound(bounds), {
              checkZoomRange: true,
            }).then(onMapInited);
          } else if (mapCenter) {
            map.setCenter(mapCenter)
              .then(onMapInited);
          } else {
            onMapInited();
          }

          contextMenu = createContextMenu(map);

          _setPresets();
        };

        this.getSelectedShapes = () => selectedShapes;

        this.geoObjectContextMenu = function (event, tag) {
          $log.debug('modal.geoObjectContextMenu', event, tag);
          var geoObject = event.get('target');
          contextMenu.show({
            geoObject: geoObject,
            position: event.get('position'),
            shapeObject: tag
          });
          // contextMenu.onSelect(function (item, event, context) {
          //   // do something
          // });
        };

        // @pure
        var isGeoObjectShouldBeHighlighted = function (geoObject) {
          return true;
          // if (
          //   isPolygon(geoObject) ||
          //   geoObject.properties.get('mouseInsideResizer')
          // ) {
          //   return true;
          // }

          // return false;
        };

        this.geoObjectPropertiesChanged = e => {
          var obj = e.get('target');
          var isHighlighted = isGeoObjectShouldBeHighlighted(obj);

          var basePresetName = isCircle(obj) ? 'circle' : 'polygon';
          var postfix = isHighlighted ? '_highlighted' : '';
          obj.options.set('preset', 'search#' + basePresetName + postfix);
        };


        var setTagGeometry = _.debounce(function (tag, geometry) {
          var updateScope = false;
          var tagGeometry = tag.geoObject.source.geometry;
          var newCoords = geometry.getCoordinates();

          if (!angular.equals(tagGeometry.coordinates, newCoords)) {
            tagGeometry.coordinates = newCoords;
            updateScope = true;
          }
          if (geometry.getType() === 'Circle') {
            var newRadius = geometry.getRadius();
            if (tagGeometry.radius !== newRadius) {
              tagGeometry.radius = newRadius;
              updateScope = true;
            }
          }
          if (updateScope) {
            $scope.$apply();
          }
        });

        this.geoObjectGeometryChanged = (e, tag) => {
          $log.debug('modal.geoObjectGeometryChanged');
          var obj = e.get('target');
          setTagGeometry(tag, obj.geometry);
          updateGeo();
        };

        this.afterGeoObjectCollectionInit = target => {
          $log.debug('modal.afterGeoObjectCollectionInit');
          geoObjectCollection = target;
        };

        this.afterDrawingGeoObjectCollectionInit = target => {
          $log.debug('modal.afterDrawingGeoObjectCollectionInit');
          drawingGeoObjectCollection = target;
        };

        this.drawingGeoObjectCollectionAdded = e => {
          $log.debug('modal.drawingGeoObjectCollectionAdded');
          var obj = e.get('child');

          // У круга нет встроенного редактора
          if (!obj.editor) return;

          // закомментил, потому что это все равно не работает
          // obj.editor.options.set({
          //   vertexLayout: ymaps.templateLayoutFactory.createClass('<div class="search-map__polygon-vertex"></div>'),
          //   edgeLayout: ymaps.templateLayoutFactory.createClass('<div class="search-map__polygon-edge"></div>')
          // });


          // @side-effect
          function stopDrawing() {
            obj.editor.stopDrawing();
            deactivateDrawing();
          }


          obj.editor.options.set({
            menuManager: function (items, model) {
              if (model.getIndex() === 0) {
                stopDrawing();
              }
              return [];
            }
          });


          // @pure
          function numbersDiff(one, two) {
            return Math.abs(one - two);
          }

          // @pure
          function square(n) {
            return n * n;
          }

          // @pure
          function twoPointsIsNear(one, two, fallibility) {
            var oneDiff = numbersDiff(one[0], two[0]);
            var twoDiff = numbersDiff(one[1], two[1]);
            return square(oneDiff) + square(twoDiff) < square(fallibility);
          }

          var CustomFirstVertex = ymaps.templateLayoutFactory.createClass(
            '<div class="search-map__polygon-vertex search-map__polygon-vertex_start js-first-vertex"></div>'
          );

          let firstVertexRadius;

          obj.editor.events.add('vertexadd', function (event) {
            var editor = event.get('target');
            var vertexIndex = event.get('vertexIndex');
            var isDrawing = editor.state.get('drawing');
            $log.debug('vertexadd');


            // !!! ХАК !!!
            // Клик на кастомную вершину не обрабытывается, поэтому при нажатии
            // на вершину создается еще одна вершина под ней и расчитывается
            // расстояние между первой и новосозданной вершинами.
            // Если оно меньше или равно радиусу первой вершины, то считаем это кликом
            // на последнюю вершину и завершаем рисование.

            if (firstVertexRadius) {
              // здесь хранятся вершины
              // координаты указыны в пиксилях относительно верхней
              // левой (?) границы всей карты (не только видимой части).
              const parentModel = event.get('parentModel');
              const vertexes = parentModel.getPixels();
              // немного шире, чтобы проще было кликнуть
              const fallibility = firstVertexRadius + 5;

              // расчитываем, достаточно ли близки две вершины
              const isLastVertex = twoPointsIsNear(
                event.get('globalPixels'),
                vertexes[vertexes.length - 1],
                fallibility
              );

              if (isLastVertex) {
                // удалить последнюю вершину
                parentModel.geometry.remove(-1);
                stopDrawing();
                return;
              }
            } else {
              const $firstVertex = document.querySelector('.js-first-vertex');
              if ($firstVertex) firstVertexRadius = $firstVertex.offsetWidth / 2;
            }

            // Кастомный внешний вид для первой вершины
            if (isDrawing && vertexIndex === 0) {
              _getFirstVertexFromEditor(editor).options.set({
                iconLayout: CustomFirstVertex
              });
            }
          });

          obj.editor.events.add('drawingstop', function () {
            // если событие вызвано удалением объекта, то ничего не делаем
            if (drawingGeoObjectCollection.getLength() === 0) {
              return;
            }

            $timeout(function () {
              var coordinates = obj.geometry.getCoordinates();
              var polygon = GeoUtils.createPolygonObject(coordinates, generateName(), {highlighted: true});
              addShape(polygon);

              deactivateDrawing();
            });
          });
        };

        this.afterGeoObjectInit = (target, tag) => {
          $log.debug('modal.afterGeoObjectInit');

          if (isCircle(target)) {
            _initCircleEditor(target, tag);
          }
        };

        this.geoObjectCollectionAdded = e => {
          $log.debug('modal.geoObjectCollectionAdded');
          var obj = e.get('child');

          _updateShapesOnMapCount();

          if (obj.editor) {
            obj.editor.options.set({
              vertexLayout: ymaps.templateLayoutFactory.createClass('<div class="search-map__polygon-vertex"></div>'),
              edgeLayout: ymaps.templateLayoutFactory.createClass('<div class="search-map__polygon-edge"></div>')
            });

            if (obj.geometry.getType() === 'Polygon') {
              obj.editor.startEditing();
            }
          }
        };

        this.geoObjectCollectionRemoved = e => {
          $log.debug('modal.geoObjectCollectionRemoved');
          _updateShapesOnMapCount();
        };

        var prevTimer = null;

        // @side-effect
        const showWarning = () => {
          this.showWarning = true;
          if (prevTimer) {
            $timeout.cancel(prevTimer);
          }
          prevTimer = $timeout(() => {
            this.showWarning = false;
          }, 2000);
        };

        // @pure
        function isTooManyShapes(shapes) {
          // max 5
          return shapes.length >= 5;
        }

        function activateDrawing(data) {
          setCursor(CURSORS.CROSSHAIR);

          drawingState.isDrawing = true;
          drawingState.mode = data.mode;

          switch (drawingState.mode) {
            case 'polygon':
              _drawPolygon();
              break;
            case 'shape':
              angular.element($window).triggerHandler('resize');
              break;
            case 'circle':
              break;
            default:
              $log.error('Error in activateDrawing: wrong mode passed');
          }
        }

        function deactivateDrawing() {
          drawingState.isDrawing = false;
          drawingGeoObjectCollection.removeAll();
          clearCursor();
        }

        this.toggleDrawing = mode => {
          $log.debug('modal.toggleDrawing');
          if (isTooManyShapes(selectedShapes)) {
            showWarning();
            return;
          }

          if (this.isDrawing(mode)) {
            $log.debug('>>> deactivate drawing in mode', mode);
            deactivateDrawing();
          } else {
            if (drawingState.isDrawing) {
              deactivateDrawing();
            }
            $log.debug('>>> activate drawing in mode', mode);
            activateDrawing({mode: mode});
          }
        };

        $scope.$on('reset', function () {
          $timeout(function () {
            angular.element('input[name=type_select]:checked').trigger('click');
          }, 100);
          _removeResizers();
        });

        this.mapClicked = e => {
          $log.debug('modal.mapClicked');
          if (this.isDrawing('circle')) {
            var coords = e.get('coords');
            var drawnCircle = new ymaps.GeoObject({
              geometry: {
                type: 'Circle',
                coordinates: coords,
                radius: GeoService.getOptimalRadius(map.getBounds())
              }
            });
            var coordinates = drawnCircle.geometry.getCoordinates();
            var radius = drawnCircle.geometry.getRadius();
            var circle = GeoUtils.createCircleObject(coordinates, radius, generateName(), {highlighted: true});
            addShape(circle);
            deactivateDrawing();
          }
        };


        this.drawingFinished = mouseCoordsArray => {
          $log.debug('modal.drawingFinished');
          var coordinates = GeoService.getPolygonGeometryFromMousePath(mouseCoordsArray, map);
          if (coordinates.length < 3) return;
          var obj = new ymaps.GeoObject({
            geometry: {
              type: 'Polygon',
              coordinates: [coordinates]
            }
          }, {
            preset: 'search#polygon_highlighted'
          });

          $timeout(function () {
            var coordinates = obj.geometry.getCoordinates();
            var polygon = GeoUtils.createPolygonObject(coordinates, generateName(), {highlighted: true});
            addShape(polygon);
            deactivateDrawing();
          });
        };

        function _updateShapesOnMapCount() {
          $log.info('_updateShapesOnMapCount');
          var objects = ymaps.geoQuery(geoObjectCollection);
          $scope.shapesOnMapCount = objects.search('geometry.type regexp "Polygon|Circle"').getLength();
        }

        function _setPresets() {
          $log.info('_setPresets');
          ymaps.option.presetStorage.add('search#polygon', YMAPS_PRESETS_CONST.POLYGON);
          ymaps.option.presetStorage.add('search#polygon_highlighted', YMAPS_PRESETS_CONST.POLYGON_HIGHLIGHTED);
          ymaps.option.presetStorage.add('search#circle', YMAPS_PRESETS_CONST.CIRCLE);
          ymaps.option.presetStorage.add('search#circle_highlighted', YMAPS_PRESETS_CONST.CIRCLE_HIGHLIGHTED);
          ymaps.option.presetStorage.add('search#pin', YMAPS_PRESETS_CONST.PIN);
          ymaps.option.presetStorage.add('search#pin_circle_resizer', YMAPS_PRESETS_CONST.PIN_CIRCLE_RESIZER);
          ymaps.option.presetStorage.add('search#invisible', YMAPS_PRESETS_CONST.PIN_INVISIBLE);
        }

        function _getFirstVertexFromEditor(editor) {
          $log.info('_getFirstVertexFromEditor');
          return editor.getViewSync().getPathViews()[0].getVertexViews()[0].getPlacemark();
        }


        function _initCircleEditor(circle, tag) {
          $log.info('_initCircleEditor');

          function setCirclePreset(preset) {
            if (circle.options.get('preset') !== preset) {
              circle.options.set({preset: preset});
            }
          }

          function _putResizer() {
            $log.info('_putResizer');
            var resizer = new ymaps.Placemark(GeoService.getCoordinatesForCircleResizer(circle), {
              hintContent: 'Перетащите, чтобы изменить радиус круга'
            }, {
              preset: 'search#pin_circle_resizer'
            });
            resizer.events.add('mousemove', function () {
              circle.properties.set('mouseInsideResizer', true);
              setCirclePreset('search#circle_highlighted');
            });
            resizer.events.add('mouseleave', function (event) {
              circle.properties.set('mouseInsideResizer', false);
              // оставляем подсветку, если курсор перемещен внутрь круга
              if (circle.geometry.contains(event.get('coords'))) return;
              setCirclePreset('search#circle');
            });
            resizer.events.add('drag', function () {
              setCirclePreset('search#circle_highlighted');
              var radius = Math.floor(
                GeoService.getDistanceBetweenTwoPoints(
                  circle.geometry.getCoordinates(),
                  resizer.geometry.getCoordinates()
                ) * 1000
              );
              circle.geometry.setRadius(radius);
            });

            return resizer;
          }

          function _addResizer() {
            var resizer = _putResizer();

            circle.events.add('drag', function () {
              resizer.geometry.setCoordinates(GeoService.getCoordinatesForCircleResizer(circle));
            });

            circle.events.add('parentchange', function (event) {
              // is circle removed?
              if (event.originalEvent.newParent === null) {
                // remove resizer
                geoObjectCollection.remove(resizer);

                // remove events
                circle.events.remove('drag');
                circle.events.remove('parentchange');
              }
            });

            geoObjectCollection.add(resizer);
          }

          _addResizer();
        }

        function _drawPolygon() {
          $log.info('_drawPolygon');
          // Создаем многоугольник без вершин.
          var drawnPolygon = new ymaps.GeoObject({
            geometry: {
              type: 'Polygon'
            }
          }, {
            preset: 'search#polygon_highlighted'
          });

          drawingGeoObjectCollection.add(drawnPolygon);
          drawnPolygon.editor.startDrawing();
        }

        function _removeResizers() {
          $log.info('_removeResizers');
          ymaps.geoQuery(geoObjectCollection)
            .search('options.preset == "search#pin_circle_resizer"')
            .removeFrom(geoObjectCollection);
        }

        this.save = () => {
          AnalyticsService.trackCA('Listing', 'popup_map_save', String(selectedShapes.length), {});
          $uibModalInstance.close(selectedShapes)
        };

        function updateGeo() {
          // Сохраняем только корректные фигуры
          // (полигон должен быть минимум треугольником)
          selectedShapes = _.filter(selectedShapes,
            shape => GeoUtils.areCoordinatesCorrect(shape.geoObject)
          );

          collectionUtils.updateSubsetOfCollectionInPlace(
            geoFilters,
            selectedShapes,
            ['polygon', 'circle']
          );

          selectedShapes.forEach(shape => {
            const geoItem = geoFilters.find(item => item.type === shape.type && item.id === shape.id);
            // Копируем всю геометрию (координаты, радиус круга)
            geoItem.geoObject.source.geometry = shape.geoObject.source.geometry;
          });
        }
      }]);



// WEBPACK FOOTER //
// ./src/components/map-draw/src/scripts/cian.map-draw.ctrl.js